import { render } from "./AdminTrips.vue?vue&type=template&id=1bc1c1d0&scoped=true"
import script from "./AdminTrips.vue?vue&type=script&lang=js"
export * from "./AdminTrips.vue?vue&type=script&lang=js"

import "./AdminTrips.vue?vue&type=style&index=0&id=1bc1c1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc1c1d0"]])

export default __exports__